import { Measurand } from "../../../../utils/backend-types";

export function getSeriesColorByMeasurand(
  seriesId: string
): string | undefined {
  const measurand = seriesId.split(".")[2];
  switch (measurand) {
    case Measurand.positive:
      return "#4269D0"; // Blue
    case Measurand.negative:
      return "#EFB118"; // Yellow
    case Measurand.reactiveCapacitive:
      return "#FF725C"; // Red
    case Measurand.reactiveInductive:
      return "#6CC5B0"; // Green
    default:
      return undefined; // No color defined for this measurand
  }
}
